import React from "react";
import Layout from "../../components/layouts/Layout";
import AdminMenu from "./AdminMenu";

const Users = () => {
  return (
    <div className="container-fluid">
      <div className="col-md-9">Users</div>
    </div>
  );
};

export default Users;
